import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { setupAuthFetchInterceptor } from './utils/authFetchInterceptor';
import { clearAuthSession, getLegacyAccessToken } from './utils/authSession';
import { BoardChatRealtimeProvider } from './features/board-chat';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Remove JWT antigo do localStorage (access token passa a ser cookie HttpOnly)
if (getLegacyAccessToken()) {
  clearAuthSession();
}

setupAuthFetchInterceptor();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter basename="">
      <BoardChatRealtimeProvider>
        <App />
      </BoardChatRealtimeProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
